import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ComponentsModule } from 'src/app/components/components.module';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';
import { HomeAcxCtaComponent } from './home-acx-cta/home-acx-cta.component';
import { HomeActionItemComponent } from './home-action-item/home-action-item.component';
import { HomeHeroComponent } from './home-hero/home-hero.component';
import { HomeOperationsPanelComponent } from './home-operations-panel/home-operations-panel.component';
import { HomeComponent } from './home.component';

@NgModule({
  declarations: [
    HomeComponent,
    HomeActionItemComponent,
    HomeHeroComponent,
    HomeOperationsPanelComponent,
    HomeAcxCtaComponent,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    B3DesignSystemWebModule,
  ],
  exports: [HomeComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeModule {}
